import { FormHandles } from '@unform/core';
import React, { createRef, FC, useContext } from 'react';
import { useMutation, gql } from '@apollo/client';
import { AuthContext } from 'routes/auth.context';
import ComponentCreateTaxa from './Component';
import { useCreateTaxa } from './hooks/useCreateTaxa';

const GRAPHQL_CRIAR_TAXA = gql`
    mutation CriarTaxa($data: CriarTaxaInput!) {
        criarTaxa(data: $data) {
            id
            dataInicio
            dataFim
            valorAdicionalJogoRapido
            valorAdicionalEntregador
            criadoEm
        }
    }
`;

const PageCreateTaxa: FC = () => {
    const { alertConfirm } = useContext(AuthContext);
    const [loading, setLoading] = React.useState(false);

    const [criarTaxaMutation] = useMutation(GRAPHQL_CRIAR_TAXA);

    const inputs = useCreateTaxa();
    const rForm = createRef<FormHandles>();

    const handleSubmit = async (data: any, { closeModal }: { closeModal: () => void }) => {
        setLoading(true);
        try {
            // Prepare the data for submission
            const taxaData = {
                dataInicio: data.dataInicio,
                dataFim: data.dataFim,
                valorAdicionalJogoRapido: data.valorAdicionalJogoRapido,
                valorAdicionalEntregador: data.valorAdicionalEntregador,
            };

            // Call the GraphQL mutation
            await criarTaxaMutation({
                variables: {
                    data: taxaData,
                },
            });

            alertConfirm({
                tipo: 'sucesso',
                titulo: 'Sucesso',
                conteudo: 'Taxa criada com sucesso!',
            });

            // Close modal after successful creation
            closeModal();
        } catch (err: any) {
            setLoading(false);
            alertConfirm({
                tipo: 'erro',
                titulo: 'Erro',
                conteudo: err.message || 'Erro ao criar taxa',
            });
        } finally {
            setLoading(false);
        }
    };

    const oProps = {
        inputs,
        loading,
        rForm,
        handleSubmit,
    };

    return <ComponentCreateTaxa {...oProps} />;
};

export default PageCreateTaxa;
